import { Label } from 'components/atoms';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import {
  PiClock,
  PiHourglassSimpleMedium,
  PiSealCheck,
  PiSealWarning,
  PiXCircle,
} from 'react-icons/pi';
import { REPORT_GENERATION_STATUS } from 'services/label-report/types';
import { IColorProp } from 'types/components/components.interface';

export interface ILabeledReportStatusProps {
  status: REPORT_GENERATION_STATUS;
}

interface ILabeledReportStatusParams extends IColorProp {
  status: REPORT_GENERATION_STATUS;
  icon: ReactNode;
}

const labeledStatusParams: ILabeledReportStatusParams[] = [
  {
    status: REPORT_GENERATION_STATUS.Waiting,
    color: 'black',
    icon: <PiClock />,
  },
  {
    status: REPORT_GENERATION_STATUS.Canceled,
    color: 'gray',
    icon: <PiXCircle />,
  },
  {
    status: REPORT_GENERATION_STATUS.Done,
    color: 'green',
    icon: <PiSealCheck />,
  },
  {
    status: REPORT_GENERATION_STATUS.Error,
    color: 'red',
    icon: <PiSealWarning />,
  },
  {
    status: REPORT_GENERATION_STATUS.InProgress,
    color: 'blue',
    icon: <PiHourglassSimpleMedium />,
  },
];

const LabeledReportStatus = ({ status }: ILabeledReportStatusProps) => {
  const { t } = useTranslation();
  const labeledParams =
    labeledStatusParams.find(params => params.status === status) ??
    labeledStatusParams[0];
  return (
    <Label
      size='compact'
      color={labeledParams.color}
      title={t(
        `enum.REPORT_GENERATION_STATUS.${
          REPORT_GENERATION_STATUS[labeledParams.status]
        }`
      )}>
      {labeledParams.icon}{' '}
      {t(
        `enum.REPORT_GENERATION_STATUS.${
          REPORT_GENERATION_STATUS[labeledParams.status]
        }`
      )}
    </Label>
  );
};

export default LabeledReportStatus;
